.context-chip {
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 16px;
  border: 1px solid var(--gray_light2);
  border-radius: 24px;
  font-size: 12px;
  color: var(--color_neutral_900);

  svg {
    color: var(--color_neutral_800);
  }

  &.with-icon {
    padding-left: 12px;
  }

  &.with-close {
    padding-right: 12px;
  }

  &.active {
    border-color: var(--color_primary_500);
    svg {
      color: var(--color_primary_500);
    }
  }

  .close-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
  }
}
